import { render, staticRenderFns } from "./ViewMessageDialog.vue?vue&type=template&id=7be46310"
import script from "./ViewMessageDialog.vue?vue&type=script&lang=js"
export * from "./ViewMessageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports